/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './multi-editor-toolbar.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../app/multi-editor/multi-editor-toolbar/multi-editor-toolbar.component';
import * as i4 from '../multi-editor-search/multi-editor-search.component.ngfactory';
import * as i5 from '../../../../app/multi-editor/multi-editor-search/multi-editor-search.component';
const styles_MultiEditorToolbarComponent:any[] = [i0.styles];
export const RenderType_MultiEditorToolbarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MultiEditorToolbarComponent,data:{}});
export function View_MultiEditorToolbarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),19,'nav',[['class',
      'navbar navbar-default'],['id','editor-toolbar']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),16,'form',[['class',
      'form-inline'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'submit'],[(null as any),'reset']],(_v,en,
      $event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,4).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,4).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(3,16384,(null as any),0,i2.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(4,16384,(null as any),0,i2.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,(null as any),i2.ControlContainer,
      (null as any),[i2.NgForm]),i1.ɵdid(6,16384,(null as any),0,i2.NgControlStatusGroup,
      [i2.ControlContainer],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),3,'button',[['class',
      'btn btn-default navbar-btn btn-success'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.MultiEditorToolbarComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.save.emit()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(10,0,(null as any),(null as any),0,'i',[['aria-hidden','true'],
          ['class','fa fa-floppy-o']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),[' Save\n    '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(13,0,(null as any),
          (null as any),4,'span',[['class','col-xs-offset-1']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(15,0,(null as any),(null as any),1,'re-multi-editor-search',
          ([] as any[]),(null as any),[[(null as any),'search'],[(null as any),'collectionChange']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.MultiEditorToolbarComponent = _v.component;
            if (('search' === en)) {
              const pd_0:any = ((<any>_co.onSearch($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('collectionChange' === en)) {
              const pd_1:any = ((<any>_co.onCollectionChange($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_MultiEditorSearchComponent_0,i4.RenderType_MultiEditorSearchComponent)),
      i1.ɵdid(16,49152,(null as any),0,i5.MultiEditorSearchComponent,([] as any[]),
          (null as any),{search:'search',collectionChange:'collectionChange'}),(_l()(),
          i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:i3.MultiEditorToolbarComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,6).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,6).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,6).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,6).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,6).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,6).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,6).ngClassPending;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_7:boolean = !_co.canSave;
    _ck(_v,8,0,currVal_7);
  });
}
export function View_MultiEditorToolbarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-multi-editor-toolbar',
      ([] as any[]),(null as any),(null as any),(null as any),View_MultiEditorToolbarComponent_0,
      RenderType_MultiEditorToolbarComponent)),i1.ɵdid(1,49152,(null as any),0,i3.MultiEditorToolbarComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const MultiEditorToolbarComponentNgFactory:i1.ComponentFactory<i3.MultiEditorToolbarComponent> = i1.ɵccf('re-multi-editor-toolbar',
    i3.MultiEditorToolbarComponent,View_MultiEditorToolbarComponent_Host_0,{canSave:'canSave'},
    {search:'search',collectionChange:'collectionChange',save:'save'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/multi-editor-toolbar/multi-editor-toolbar.component.ngfactory.ts